export default {
  queries: {
    movieDetail: {
      fields: ['movie']
    }
  }
};
